import { withErrorBoundary } from 'components/ErrorBoundary';
import { useEffect, useState } from 'react';
import { UIFragments } from 'utils/log/constants/uiFragments';
import * as S from './StickyCTAStyles';

export interface StickyCTAProps {
  children: React.ReactNode;
  dataCy?: string;
}

const StickyCTA = (props: StickyCTAProps) => {
  const { children, dataCy } = props;

  const [bannerIsClosed, setBannerIsClosed] = useState(false);
  const [displayBanner, setDisplayBanner] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setDisplayBanner(window.scrollY > window.innerHeight * 0.8);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!displayBanner || bannerIsClosed) {
    return null;
  }

  return (
    <S.Wrapper data-cy={dataCy}>
      <S.Container>
        {children}
        <S.CloseButton
          onClick={() => setBannerIsClosed(true)}
          aria-label='close'
        />
      </S.Container>
    </S.Wrapper>
  );
};

export default withErrorBoundary(StickyCTA, { fragment: UIFragments.STICKY_CTA });
